<template>
    <global-layout class="m-global-layout">
        <div class="reload-btn" v-show="isShowRefreshBtn"><a
            @click="$store.commit('router/refreshPage',$route.meta.comName)">
            <a-icon type="reload"/>
            <span>刷新</span></a></div>
        <contextmenu
            :itemList="menuItemList"
            :visible.sync="menuVisible"
            @select="onMenuSelect"
        />
        <a-tabs
            class="m-tabs"
            @contextmenu.native="e => onContextmenu(e)"
            v-if="multipage"
            :active-key="activePage"
            style="margin-top: -8px; margin-bottom: 8px"
            :hide-add="true"
            type="editable-card"
            @change="changePage"
            @edit="editPage"
        >
            <a-tab-pane
                :id="page.fullPath"
                :key="page.fullPath"
                v-for="page in pageList"
            >
        <span
            slot="tab"
            :pagekey="page.fullPath"
        >{{ formatePageName(page.name) }} </span>
            </a-tab-pane>
        </a-tabs>
        <transition name="page-toggle">
            <keep-alive
                v-if="multipage"
                :include="includeComponents"
            >
                <router-view :key="$route.fullPath"/>
            </keep-alive>
            <router-view
                v-else
                :key="$route.fullPath"
            />
        </transition>
    </global-layout>
</template>

<script>
import GlobalLayout from "./GlobalLayout";
import Contextmenu from "../components/menu/Contextmenu";
import { setTimeout } from "timers";

const MAX_TABS = 20; // 页签最大数量
export default {
    name: "MenuView",
    components: { Contextmenu, GlobalLayout },
    data() {
        return {
            pageList: [], // 记录当前展示页签的route
            linkList: [],
            activePage: "",

            menuVisible: false,
            menuItemList: [
                { key: "1", icon: "arrow-left", text: "关闭左侧" },
                { key: "2", icon: "arrow-right", text: "关闭右侧" },
                { key: "3", icon: "close", text: "关闭其它" }
            ]
        };
    },
    computed: {
        multipage() {
            return this.$store.state.setting.multipage;
        },
        includeComponents() {
            // console.log("计算变化", new Date());
            return this.$store.state.router.keepAliveComponents;
        },
        isShowRefreshBtn() {
            return this.$route.meta.needRefresh === true;
        }
    },
    created() {
        this.pageList.push(this.$route);
        this.linkList.push(this.$route.fullPath);
        this.$store.commit("router/addToKeepAlive", this.$route.meta.comName);
        this.activePage = this.$route.fullPath;
    },
    watch: {
        "$store.state.router.toCloseTab": function(newValue, oldValue) {
            this.remove(newValue.pagePath, true);
        },
        pageList: function(newValue) {
            this.$store.commit("router/setRouterList", newValue);
        },
        $route: function(newRoute, oldRoute) {
            // console.log("$route变化")

            if (!this.multipage) {
                this.linkList = [newRoute.fullPath];
                this.pageList = [newRoute];
                this.activePage = newRoute.fullPath;
            } else {
                let index = this.pageList.findIndex(
                    item => item.path === newRoute.path
                );
                if (index < 0) {
                    // 当前路由对应的组件没有打开的页签
                    this.linkList.push(newRoute.fullPath);
                    this.pageList.push(newRoute);
                    this.$store.commit(
                        "router/addToKeepAlive",
                        newRoute.meta.comName
                    );

                    // 如果页签达到上限，关掉第一个页签
                    if (this.pageList.length > MAX_TABS) {
                        let comName = this.pageList[0].meta.comName;
                        this.pageList.splice(0, 1);
                        this.linkList.splice(0, 1);
                        this.$store.commit("router/removeFromKeepAlive", {
                            comName: comName,
                            from: "exceedTabs"
                        });
                    }
                    this.activePage = newRoute.fullPath;
                } else {
                    // 再次打开同类型的页签，且参数与之前不同
                    if (this.pageList[index].fullPath !== newRoute.fullPath) {
                        this.pageList.splice(index, 1, newRoute);
                        this.linkList.splice(index, 1, newRoute.fullPath);
                        this.$store.commit(
                            "router/addToKeepAlive",
                            newRoute.meta.comName
                        );
                        this.activePage = newRoute.fullPath;
                    } else {
                        this.activePage = newRoute.fullPath;
                    }
                }
            }

            // console.log('$router',this.$router)
            // console.log('$route',this.$route);
            //     console.log(' newRoute', newRoute);

            // console.log('pageList',this.pageList)
            // console.log('linkList',this.linkList)
        },
        activePage: function(key) {
            //  console.log("activePage变化，push")
            this.$router.push(key);
        },
        multipage: function(newVal, oldVal) {
            if (!newVal) {
                this.linkList = [this.$route.fullPath];
                this.pageList = [this.$route];
            }
        }
    },
    methods: {
        changePage(key) {
            this.activePage = key;
        },
        editPage(key, action) {
            this[action](key);
        },
        remove(key, isFromStore) {
            if (this.pageList.length === 1 && !isFromStore) {
                this.$message.warning("这是最后一页，不能再关闭了啦");
                return;
            }

            this.pageList = this.pageList.filter(item => {
                if (item.fullPath === key) {
                    this.$store.commit("router/removeFromKeepAlive", {
                        comName: item.meta.comName,
                        from: "removeKey"
                    });
                }
                return item.fullPath !== key;
            });
            let index = this.linkList.indexOf(key);
            this.linkList = this.linkList.filter(item => item !== key);
            index =
                index >= this.linkList.length
                    ? this.linkList.length - 1
                    : index;
            this.activePage = index === -1 ? "/home" : this.linkList[index];
        },
        onContextmenu(e) {
            const pagekey = this.getPageKey(e.target);
            if (pagekey !== null) {
                e.preventDefault();
                this.menuVisible = true;
            }
        },
        /**
         * 由于ant-design-vue组件库的TabPane组件暂不支持自定义监听器，无法直接获取到右键target所在标签页的 pagekey 。故增加此方法用于
         * 查询右键target所在标签页的标识 pagekey ，以用于自定义右键菜单的事件处理。
         * 注：TabPane组件支持自定义监听器后可去除该方法并重构 ‘自定义右键菜单的事件处理’
         * @param target 查询开始目标
         * @param count 查询层级深度 （查找层级最多不超过3层，超过3层深度直接返回 null）
         * @returns {String}
         */
        getPageKey(target, depth) {
            depth = depth || 0;
            if (depth > 2) {
                return null;
            }
            let pageKey = target.getAttribute("pagekey");
            pageKey =
                pageKey ||
                (target.previousElementSibling
                    ? target.previousElementSibling.getAttribute("pagekey")
                    : null);
            return (
                pageKey ||
                (target.firstElementChild
                    ? this.getPageKey(target.firstElementChild, ++depth)
                    : null)
            );
        },
        onMenuSelect(key, target) {
            let pageKey = this.getPageKey(target);
            switch (key) {
                case "1":
                    this.closeLeft(pageKey);
                    break;
                case "2":
                    this.closeRight(pageKey);
                    break;
                case "3":
                    this.closeOthers(pageKey);
                    break;
                default:
                    break;
            }
        },
        closeOthers(pageKey) {
            let index = this.linkList.indexOf(pageKey);
            this.linkList = this.linkList.slice(index, index + 1);
            this.pageList = this.pageList.slice(index, index + 1);
            this.activePage = this.linkList[0];
        },
        closeLeft(pageKey) {
            let index = this.linkList.indexOf(pageKey);
            this.linkList = this.linkList.slice(index);
            this.pageList = this.pageList.slice(index);
            if (this.linkList.indexOf(this.activePage) < 0) {
                this.activePage = this.linkList[0];
            }
        },
        closeRight(pageKey) {
            let index = this.linkList.indexOf(pageKey);
            this.linkList = this.linkList.slice(0, index + 1);
            this.pageList = this.pageList.slice(0, index + 1);
            if (this.linkList.indexOf(this.activePage < 0)) {
                this.activePage = this.linkList[this.linkList.length - 1];
            }
        },
        formatePageName (routeName) {
            if (routeName === '超值换购活动') {
                let pageType = this.$route.query.pageType
                let str = ''
                switch (pageType) {
                    case 'create':
                        str = '新建'
                        break
                    case 'update':
                        str = '更新'
                        break
                    case 'copy':
                        str = '复制'
                        break
                    case 'view':
                        str = '查看'
                        break
                }
                return `${routeName}${str}`
            }
            if (routeName === '销售管控') {
                let user = this.$store.state.account.user
                return user.storeType === '1' ? '销售管控' : '采销管控'
            }
            return routeName
        }
    }
};
</script>

<style lang="less" scoped>
.m-tabs {
    width: calc(100% - 45px);
}

.m-global-layout {
    position: relative;

    .reload-btn {
        position: absolute;
        right: 25px;
        top: 90px;
    }
}
</style>



// WEBPACK FOOTER //
// src/layouts/MenuView.vue